import TranslateCreateForm from "./translate-create-form";

export default TranslateCreateForm;